module.exports = __webpack_public_path__ + "static/case-hp-03-a5c0803c5c3ef351b097db6b187813b9.jpg";